(function () {
  function fixMarketLinks() {
    var isSweden = window.location.hostname.endsWith('.se');
    var mappings = isSweden
      ? {
          '/products/rejuvenate': '/products/femarelle-rejuvenate-se',
          '/products/recharge': '/products/femarelle-recharge-se',
          '/products/unstoppable': '/products/femarelle-unstoppable-se'
        }
      : {
          '/products/rejuvenate': '/products/femarelle-rejuvenate',
          '/products/recharge': '/products/femarelle-recharge',
          '/products/unstoppable': '/products/femarelle-unstoppable'
        };

    document.querySelectorAll('a[href]').forEach(function (link) {
      var url;
      try {
        url = new URL(link.href, window.location.origin);
      } catch (error) {
        return;
      }

      if (mappings[url.pathname]) {
        link.href = window.location.origin + mappings[url.pathname];
      }

      if (isSweden && url.pathname === '/sv/policies/privacy-policy') {
        link.href = 'https://femarelle.se/pages/privatlivspolitik';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixMarketLinks);
  } else {
    fixMarketLinks();
  }

  new MutationObserver(fixMarketLinks).observe(document.documentElement, { childList: true, subtree: true });
})();
